function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from '../../../../_snowpack/pkg/react.js';
import { colors } from '../../../css/index.js';

function UserCard({
  size = 20,
  color = colors.green,
  strokeColor = colors.label,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: ref,
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 6.25C1.25 5.55964 1.80964 5 2.5 5H17.5C18.1904 5 18.75 5.55964 18.75 6.25V15C18.75 15.6904 18.1904 16.25 17.5 16.25H2.5C1.80964 16.25 1.25 15.6904 1.25 15V6.25Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 5.5H2.5C2.08579 5.5 1.75 5.83579 1.75 6.25V15C1.75 15.4142 2.08579 15.75 2.5 15.75H17.5C17.9142 15.75 18.25 15.4142 18.25 15V6.25C18.25 5.83579 17.9142 5.5 17.5 5.5ZM2.5 5C1.80964 5 1.25 5.55964 1.25 6.25V15C1.25 15.6904 1.80964 16.25 2.5 16.25H17.5C18.1904 16.25 18.75 15.6904 18.75 15V6.25C18.75 5.55964 18.1904 5 17.5 5H2.5Z",
    fill: strokeColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 10.625C8.75 12.0057 7.63071 13.125 6.25 13.125C4.86929 13.125 3.75 12.0057 3.75 10.625C3.75 9.24429 4.86929 8.125 6.25 8.125C7.63071 8.125 8.75 9.24429 8.75 10.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 10.625C9.25 12.2819 7.90685 13.625 6.25 13.625C4.59315 13.625 3.25 12.2819 3.25 10.625C3.25 8.96815 4.59315 7.625 6.25 7.625C7.90685 7.625 9.25 8.96815 9.25 10.625ZM6.25 13.125C7.63071 13.125 8.75 12.0057 8.75 10.625C8.75 9.24429 7.63071 8.125 6.25 8.125C4.86929 8.125 3.75 9.24429 3.75 10.625C3.75 12.0057 4.86929 13.125 6.25 13.125Z",
    fill: strokeColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 9.375C16.25 9.72018 15.9702 10 15.625 10L11.25 10C10.9048 10 10.625 9.72018 10.625 9.375C10.625 9.02982 10.9048 8.75 11.25 8.75L15.625 8.75C15.9702 8.75 16.25 9.02982 16.25 9.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.625 10.5L11.25 10.5C10.6287 10.5 10.125 9.99632 10.125 9.375C10.125 8.75368 10.6287 8.25 11.25 8.25L15.625 8.25C16.2463 8.25 16.75 8.75368 16.75 9.375C16.75 9.99632 16.2463 10.5 15.625 10.5ZM15.625 10C15.9702 10 16.25 9.72018 16.25 9.375C16.25 9.02982 15.9702 8.75 15.625 8.75L11.25 8.75C10.9048 8.75 10.625 9.02982 10.625 9.375C10.625 9.72018 10.9048 10 11.25 10L15.625 10Z",
    fill: strokeColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.875C12.5 12.2202 12.2202 12.5 11.875 12.5L11.25 12.5C10.9048 12.5 10.625 12.2202 10.625 11.875C10.625 11.5298 10.9048 11.25 11.25 11.25L11.875 11.25C12.2202 11.25 12.5 11.5298 12.5 11.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.875 13L11.25 13C10.6287 13 10.125 12.4963 10.125 11.875C10.125 11.2537 10.6287 10.75 11.25 10.75L11.875 10.75C12.4963 10.75 13 11.2537 13 11.875C13 12.4963 12.4963 13 11.875 13ZM11.875 12.5C12.2202 12.5 12.5 12.2202 12.5 11.875C12.5 11.5298 12.2202 11.25 11.875 11.25L11.25 11.25C10.9048 11.25 10.625 11.5298 10.625 11.875C10.625 12.2202 10.9048 12.5 11.25 12.5L11.875 12.5Z",
    fill: strokeColor
  }));
}

export default /*#__PURE__*/forwardRef(UserCard);